export default __webpack_public_path__ + "static/media/ISAN2024.70a34f5e.pdf";